<template lang="html">

    <div class="cover-popup row-center">

        <span class="close-cover" @click="close"></span>

        <div class="popup">

            <a @click="close" class="close">✕</a>

            <h2 class="title-pop">Editar imagen de perfil</h2>

            <div class="magic-zone">

                <dropzone v-if="!!!img" @emit="setDoc" ref="dropzone"
                    :onlyimg="true"></dropzone>

                <cropper v-if="!!img" classname="cropper" :src="img"
                    :stencil-props="{
                    aspectRatio: 1/1
                    }" @change="change"
                    :stencilComponent="$options.components.CircleStencil"></cropper>
            </div>

            <div class="contenedor-botones row-center">
                <button class="btn" @click="setImg" :loading="loading">Guardar</button>
                <button class="btn -skull" @click="eraseImg">Eliminar</button>
            </div>
        </div>
    </div>


</template>

<script lang="js">

    import Vue from 'vue';
    import VeeValidate from 'vee-validate';
    Vue.use(VeeValidate);

    import { Cropper, CircleStencil } from 'vue-advanced-cropper'


    import {mapActions} from 'vuex';

    import dropzone from '@/components/parts/dropzone';

    export default {
        name: 'image-editor',
        props : ['avatarimg'],
        data() {
            return {
                img: '',
                imgb64: '',
                extension : '',
                nombre : '',
                loading : false
            }
        },
        methods: {
            ...mapActions(['editImagenPerfil']),
            setDoc(value) {
                this.img = value.ficheroB64ParaAltas;
                this.extension = value.extension_adjunto;
                this.nombre = value.nombre;
            },
            change({ coordinates, canvas }) {
                this.imgb64 = canvas.toDataURL();
                console.log(canvas);
            },
            eraseImg() {
                this.img = '';
                this.imgb64 = '';
            },
            setImg() {

                let data = {
                    "ficheroBase64": this.imgb64.replace('data:image/png;base64,',''),
                    "extension": this.extension,
                    "nombre": this.nombre
                }

                this.loading = true;

                this.editImagenPerfil(data).then(r => {
                    this.$emit('setImg', this.imgb64);
                    this.close();
                    this.loading = false;
                });

            },
            close() {
                this.$emit('close');
            }
        },
        components: {
            'dropzone': dropzone,
            Cropper,
            CircleStencil
        }
    }
</script>

<style scoped lang="scss">
    .cover-popup .popup .btn {
        margin-top: 0;
    }
</style>


// WEBPACK FOOTER //
// src/components/view-parts/espacio-personal/image-editor.vue